import { useEffect, useState } from 'react'

import { useQuote } from '../../../../../hooks/useQuote'
import { useCarPageContext } from '../../../../../pages/CarPageProvider'
import { usePreQuoteContext } from '../../../../../pages/PageValidator'
import { CarMileage } from '../CarMileage'

export const CarMileageContainer = () => {
  const quote = useQuote()
  const { handleUpdateCarDetails } = useCarPageContext()
  const { showErrorBanner, updateValidInputs, validInputs, notAnsweredMessage } = usePreQuoteContext()
  const { mileage } = Object.fromEntries(new URLSearchParams(window?.location?.search))

  const [updatedMileage, setUpdatedMileage] = useState<number | undefined>(undefined)
  const [mileageError, setMileageError] = useState('')
  const mileageLimit = 100000

  useEffect(() => {
    const qqMileage = parseInt(mileage) || null
    if (qqMileage) {
      const isValid = qqMileage !== 0 && qqMileage < mileageLimit
      setUpdatedMileage(isValid ? qqMileage : undefined)
      handleUpdateCarDetails({ estimated_mileage: qqMileage })
    } else {
      setUpdatedMileage(quote?.details?.vehicle?.estimated_mileage || undefined)
    }
  }, [])

  useEffect(() => {
    updateValidInputs({
      field: 'mileage',
      value: typeof updatedMileage === 'number' && updatedMileage > 0 && updatedMileage < mileageLimit,
    })
  }, [updatedMileage])

  const handleUpdateMileage = (value: string) => {
    const isValid = parseInt(value) !== 0 && parseInt(value) < mileageLimit
    const estimated_mileage = parseInt(value)
    setUpdatedMileage(estimated_mileage)
    handleUpdateCarDetails({ estimated_mileage })
    if (isValid) {
      setMileageError('')
    } else if (parseInt(value)) {
      setMileageError('This seems a bit high, please double check and try again.')
    } else {
      setMileageError(
        parseInt(value) === 0 ? 'Please select a mileage larger than 0.' : 'Please answer this question to continue',
      )
    }
  }

  return (
    <CarMileage
      updatedMileage={updatedMileage}
      showErrorBanner={showErrorBanner}
      handleUpdateMileage={handleUpdateMileage}
      validInputs={validInputs}
      notAnsweredMessage={notAnsweredMessage}
      mileageError={mileageError}
    />
  )
}
